import MenuItemInfo from "@/domain/entities/navbar/MenuItemInfo";
import { MenulInfo } from "@cs_teamwaydev/mailvista-sdk_react";

const menuItemInfoMapper = (menuItemInfo: MenulInfo): MenuItemInfo =>
    new MenuItemInfo({
        color: menuItemInfo.color,
        title: menuItemInfo.title,
        icon: menuItemInfo.icon,
    });

export default menuItemInfoMapper;
